import React, { Component } from "react";
import Card from "components/Card/Card.jsx";
import 'bootstrap/dist/css/bootstrap.min.css';
import { MDBContainer, MDBRow, MDBCol, DataTable } from 'mdbreact';
import "react-checkbox-tree/lib/react-checkbox-tree.css";
import { Row, Col } from "reactstrap";
// import BootstrapTable from 'react-bootstrap-table-next';
// import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
// import paginationFactory from 'react-bootstrap-table2-paginator';
// import ToolkitProvider, { Search , CSVExport } from 'react-bootstrap-table2-toolkit';
import "@y0c/react-datepicker/assets/styles/calendar.scss";
import 'react-checkbox-tree/lib/react-checkbox-tree.css';
import { Redirect } from 'react-router-dom';
import SweetAlert from 'react-bootstrap-sweetalert';
import { DatePicker } from "@y0c/react-datepicker";
import  ReactDataTable from "components/PageElements/ReactDataTable";


class AgeingReport extends React.Component {

constructor(props) {
  super(props);
  this.state = {

    date: new Date(),
    currentStep: 1,
    alert: null,
    email:  '',
    username: '',
    password: '', 
    inherit: '',
    role: '',
    city: '',
    active: '',
  hide: false,
  checkedItems: new Map(),
  checked: [],
  expanded: [],
  alert: null,
  showRole: false,
  alertB: null,
  rows: [{}],
  showTable: false,
  };

  this._onButtonClick = this._onButtonClick.bind(this);

 
}
_onButtonClick() {
  const getAlert = () => (
    <SweetAlert 
    success 
    title="Success!" 
    onConfirm={() => this.hideAlertB()}
  >
    Data Saved Sucessfully!
  </SweetAlert>
  )
  this.setState({
    alertB: getAlert(),
    
   });
}
hideAlertB() {
  console.log('Hiding alert...');
  this.setState({
    alertB: null
  });
}

hideAlert() {
  console.log('Hiding alert...');
  this.setState({
    alert: null
  });
}
openDatatable = (e) => {
    e.preventDefault();
    this.setState({
       showTable:true
      });
}
resetForm = (e) => {
    e.preventDefault();
    document.getElementById("myForm").reset();
    this.setState({
        showTable:false
       });
}

render() {
    const onChange = title => (...args) => console.log(title, args);
  if (this.state.showRole) {
    // redirect to home if signed up
    return <Redirect to = {{ pathname: "/admin/dashboard/landing" }} />;
  }
  // const { ExportCSVButton } = CSVExport;
  // const { SearchBar, ClearSearchButton } = Search
  const data = [
      
      
    ];
  
      const columns = [
        {
          dataField: "locationName",
          text: "Location Name",
          sort: true
        },
        {
            dataField: "storageLocation",
            text: "Storage Location",
            sort: true
          },
        {
          dataField: "materialCode",
          text: "Material Code",
          sort: true
        },
        {
          dataField: "materialName",
          text: "Material Name",
         sort: true
        },
        {
            dataField: "filter1",
            text: ">100 Days",
            sort: true
        },
        {
            dataField: "filter2",
            text: "99-80 Days",
            sort: true
        },
        ,
        {
            dataField: "filter3",
            text: "79-60 Days",
            sort: true
        },
        {
            dataField: "filter4",
            text: "59-40 Days",
            sort: true
        },
        {
            dataField: "filter5",
            text: "<40 Days",
            sort: true
        }
    ];
    
  return (
  
    <Row style={{marginTop:'25px',marginBottom:'150px'}}>
      
    <Col md={1}></Col>
      <Col md={12} >
        <Card 
          title="Ageing Report"
          content={
            <>
                <div>
        {/* <div className="container">
          <div className="row clearfix">
            <div className="col-md-12 column"> */}
           
             <MDBContainer>
             <form id="myForm">
         <MDBRow>
         
         <MDBCol md="3" className="mb-3">
             <div className="form-group">
             <label
               htmlFor="defaultFormRegisterEmailEx2"
               className="grey-text"
             >
               Location
             </label> <select  className="form-control" id="inherit" name="inherit" 
           // onChange={props.handleChange}
               required>
                   <option className="form-control">Please select</option>
         <option className="form-control">Palakkad</option>
         <option className="form-control">Angamaly</option>
         <option className="form-control">Coimbatore</option>
       
       </select>
            </div>
           </MDBCol>
                    
        <MDBCol md="3" className="mb-3">
          <br></br>
         <button
                onClick={this.openDatatable}
                className="btn btn-primary float-right"
              >
                Search
              </button>
              <button
               onClick={this.resetForm}
                className="btn btn-dark float-right"
              >
                Reset
              </button>
           </MDBCol>
           </MDBRow>
    </form>
           </MDBContainer>

           <hr></hr>
           {
        this.state.showTable ?
        
    <ReactDataTable data={data} columns={columns}/>
    
        :
            ''
    
           }
            </div>
    
      </>
          }
        />
      </Col>
    <Col md={1} ></Col>
    </Row>
  );
}
}




export default AgeingReport;